export const MAPPINGS = {
  names: new Map([
    ['others', 'other'],
    ['othergames', 'other']
  ])
};
